import { useEffect } from 'react';
import { Box, Stack } from '@mui/material';
import { useSnapshot } from 'valtio';
import GeneralErrorPage from '../../../common/components/GeneralErrorPage';
import { useCallbackPrompt } from 'react-utils';
import fetchActiveProfileOverviewAction from '../../actions/profiles-actions/fetch-active-profile-overview-action';
import SaveAsNewProfileModal from '../../components/SaveAsNewProfileModal/SaveAsNewProfileModal';
import UnSavedChangesModal from '../../components/UnSavedChangesModal/UnSavedChangesModal';
import UnSavedProfileChangesModal from '../../components/UnSavedProfileChangesModal/UnSavedProfileChangesModal';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import CatergoriesAccordion from '../CatergoriesAccordion/CatergoriesAccordion';
import ProfileSelectionPanel from '../ProfileSelectionPanel/ProfileSelectionPanel';

const PoliciesContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { savePoliciesInProgress, disableSavePoliciesButton } = useSnapshot(
    PoliciesProfileUIStateStore,
  );
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
    !disableSavePoliciesButton,
  );

  const { generalPoliciesPageError } = useSnapshot(PoliciesProfileUIStateStore);
  useEffect(() => {
    fetchActiveProfileOverviewAction();
  }, []);

  if (generalPoliciesPageError !== null) {
    const { errorTitle, errorMsg } = generalPoliciesPageError;
    return <GeneralErrorPage errorTitle={errorTitle} errorMsg={errorMsg} />;
  }

  return (
    <Stack
      sx={theme => ({
        paddingInline: theme.spacing(2),
        height: '100%',
        overflowY: 'visible',
        flex: '1 1 auto',
      })}>
      <Box
        sx={theme => ({
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          boxSizing: 'border-box',
          borderRadius: theme.shape.borderRadius,
        })}>
        <ProfileSelectionPanel />
      </Box>
      <Box
        sx={theme => ({
          marginBlock: 1,
          height: '70vh',
          flex: '1 1 auto',
          overflowY: 'auto',
          backgroundColor: theme.palette.background.paper,
          boxShadow: theme.shadows[1],
          boxSizing: 'border-box',
          borderRadius: theme.shape.borderRadius,
        })}>
        <CatergoriesAccordion />
      </Box>
      <SaveAsNewProfileModal />
      <UnSavedProfileChangesModal />
      <UnSavedChangesModal
        cancelNavigation={cancelNavigation}
        confirmNavigation={confirmNavigation}
        savePoliciesInProgress={savePoliciesInProgress}
        open={showPrompt}
      />
    </Stack>
  );
};

export default PoliciesContainer;
